import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Snackbar } from '@material-ui/core'
import DynamicForm from '../DynamicForm/DynamicForm'
import { Schema } from './InputSchema'
import { Flex, Box } from 'reflexbox'
import set from 'set-value'
import HealtheraFooter from '../HealtheraFooter/HealtheraFooter'
import { HeaderContainer, HeaderTitle, BounceAnimatedContainer, PaperContainer, HorizontalRule, CentredContainer, HealtheraButton } from '../../healtheraComponents'
import styled from 'styled-components'
import BackupIcon from '@material-ui/icons/Backup'
import * as actions from '../../redux/organisations'

function BrandingLinks(props) {

  const [validationArray, setValidationArray] = useState([])
  const [accountDetails, setAccountDetails] = useState({})
  const [brandColor, setBrandColor] = useState(null)
  const [secondBrandColor, setSecondBrandColor] = useState(null)
  const [logoWhite, setLogoWhite] = useState({ files: [] })
  const [logo, setLogo] = useState({ files: [] })
  const [logoInput, setLogoInput] = useState(null)
  const [logoWhiteInput, setLogoWhiteInput] = useState(null)
  const [successMessage, setSuccessMessage] = useState('')

  const { organisation = {}, orgID } = props
  const schema = Schema(organisation, brandColor, secondBrandColor)

  const { organisation: { branding: currentBranding = {} } = {} } = useSelector(state => state.organisations)
  const dispatch = useDispatch()

  const onChange = ({ field, value, validation }) => {
    set(validationArray, field, validation)
    set(accountDetails, field, value)
    setValidationArray(validationArray)
    setAccountDetails(accountDetails)
    const { branding: { brand_colour, brand_colour_secondary } = {} } = accountDetails
    if (brand_colour || brand_colour_secondary) {
      setValidationArray(validationArray)
      setBrandColor(brand_colour)
      setSecondBrandColor(brand_colour_secondary)
    }
  }

  const onChangeFile = (callback, value) => {
    try {
      if (value.files[0]) {
        if (value.files[0].size < 15000000) {
          callback(value)
        } else {
          alert('logo size is too big')
        }
      }
    } catch (e) { }
  }

  const handleSubmit = async () => {
    try {
      if (logo.files[0] || logoWhite.files[0]) {
        const fd = new FormData()
        if (logo.files[0]) fd.append('logo_url', logo.files[0])
        if (logoWhite.files[0]) fd.append('logo_url_white', logoWhite.files[0])
        await dispatch(actions.updateOrganisation(orgID, fd))
      }
      await dispatch(actions.updateOrganisation(orgID, accountDetails))
      await dispatch(actions.getOrganisation(orgID))
      setSuccessMessage('Branding assets saved successfully')
    } catch (error) {
      setSuccessMessage('Failed to save branding assets')
    }
  }

  return (
    <>
      <Snackbar
        open={!!successMessage}
        onClose={() => setSuccessMessage('')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={3000}
        message={successMessage}
      />
      {organisation && <BounceAnimatedContainer>
        <PaperContainer $margintop={26} elevation={0}>
          <HeaderContainer marginright={`0px`} padding={`0 0 20px 0`}>
            <HeaderTitle fontSize={`24px`}>Brand Assets & Links</HeaderTitle>
          </HeaderContainer>
          <Flex>
            <Box w={`50%`}><DynamicForm onChange={onChange} fields={schema.brandingLeft} /></Box>
            <Box w={`50%`}>
              <Flex style={flexStyles}>
                <Box width={1 / 4}>
                  <LogoView src={currentBranding.logo_url} />
                </Box>
                <Box width={1 / 4}>
                  <FileSelector type='file' name='logo_url' id='logo_url' ref={ref => setLogoInput(ref)}
                    onChange={() => onChangeFile(setLogo, logoInput)} accept="image/png, image/jpeg"
                  />
                  <FileLabel htmlFor='logo_url'>{(logo.files[0] && logo.files[0].name) || <>Choose a logo <BackupIcon /></>}</FileLabel>
                </Box>
                <Box width={1 / 4}>
                  <LogoView src={currentBranding.logo_url_white} />
                </Box>
                <Box width={1 / 4}>
                  <FileSelector type='file' name='logo_url_white' id='logo_url_white' ref={ref => setLogoWhiteInput(ref)}
                    onChange={() => onChangeFile(setLogoWhite, logoWhiteInput)} accept="image/png, image/jpeg"
                  />
                  <FileLabel htmlFor='logo_url_white'>{(logoWhite.files[0] && logoWhite.files[0].name) || <>Choose a white logo <BackupIcon /></>}</FileLabel>
                </Box>
              </Flex>
            </Box>
          </Flex>
          <HorizontalRule margin={`50px 0 0 0`} />
          <Flex>
            <Box w={`50%`}><DynamicForm onChange={onChange} fields={schema.mobileAppLinksLeft} /></Box>
            <Box w={`50%`}><DynamicForm onChange={onChange} fields={schema.mobileAppLinksRight} /></Box>
          </Flex>
          <CentredContainer padding={`40px 0 20px 0`}>
            <HealtheraButton onClick={handleSubmit}>Save</HealtheraButton>
          </CentredContainer>
        </PaperContainer>
        {orgID && <HealtheraFooter />}
      </BounceAnimatedContainer>}
    </>
  )
}

export default BrandingLinks

const FileSelector = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  cursor: pointer;
`

const FileLabel = styled.label`
  font-size: 1em;
  font-weight: 700;
  color: #2f9d6d;
  background-color: #FFFFFF;
  border: 2.5px solid #2f9d6d;
  display: inline-block;
  cursor: pointer;
  padding: 15px;
  margin: 10px;
  border-radius: 25px;
  width: 300px;
  text-align: center;
`

const LogoView = styled.img`
  width: 100px;
`

const flexStyles = {
  flexDirection: 'column',
  justifyContent: 'space-around',
  backgroundSize: 'auto auto',
  backgroundColor: '#EFEFEF',
  borderRadius: '20px',
  alignItems: 'center',
  height: '100%',
  margin: '20px'
}
